import { render, staticRenderFns } from "./deductionDetail-situation.vue?vue&type=template&id=741d8986&scoped=true"
import script from "./deductionDetail-situation.vue?vue&type=script&lang=js"
export * from "./deductionDetail-situation.vue?vue&type=script&lang=js"
import style0 from "./deductionDetail-situation.vue?vue&type=style&index=0&id=741d8986&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d8986",
  null
  
)

export default component.exports